import api from "./api";
const endpoint = "ExternalCV";
export const CVService = {
  async getCVList(filtre) {
    try {
      const result = await api.get(endpoint + "/liste_cv", { params: filtre });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getCVListByUser(user_id) {
    try {
      const result = await api.get(endpoint + "/liste_cv", {
        params: { user_id: user_id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getCVById(cv_id) {
    try {
      const result = await api.get(endpoint + "/one_cv", {
        params: { id_identite: cv_id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async findOneById(id) {
    try {
      const result = await api.get(endpoint + "/offre_detail", {
        params: { id: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insertCV(data) {
    try {
      const result = await api.post(endpoint + "/insert_cv", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async updateCV(data) {
    try {
      const result = await api.post(endpoint + "/update_cv", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async duplicateCV(id_type, id_identite) {
    try {
      const result = await api.post(endpoint + "/duplicate_cv", {
        id_type: id_type,
        id_identite: id_identite,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  //experience
  async insertExperience(data) {
    try {
      const result = await api.post(endpoint + "/insertExperience", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async updateExperience(data) {
    try {
      const result = await api.post(endpoint + "/updateExperience", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async deleteExperience(id) {
    try {
      const result = await api.post(endpoint + "/delete_experience", {
        id_experience: id,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getExperienceById(id) {
    try {
      const result = await api.get(endpoint + "/experience_by_id", {
        params: { id: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getExperienceList(filtre) {
    try {
      const result = await api.get(endpoint + "/experience_list", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  ///EDUCATION
  async getEducationList(filtre) {
    try {
      const result = await api.get(endpoint + "/education_list", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insertEducation(data) {
    try {
      const result = await api.post(endpoint + "/insert_education", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async updateEducation(data) {
    try {
      const result = await api.post(endpoint + "/update_education", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async deleteEducation(id) {
    try {
      const result = await api.post(endpoint + "/delete_education", {
        id_etude: id,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getEducationByCVId(id) {
    try {
      const result = await api.get(endpoint + "/education_detail", {
        params: { id: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getEducationById(id) {
    try {
      const result = await api.get(endpoint + "/education_by_id", {
        params: { id_etude: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  //DOMAINE DE COMPETENCE
  async getDomaineCompetenceById(id) {
    try {
      const result = await api.get(endpoint + "/domaine_competence_detail", {
        params: { id: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insertDomaineCompetence(data) {
    try {
      const result = await api.post(
        endpoint + "/insert_domaine_competence",
        data
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async updateDomaineCompetence(data) {
    try {
      const result = await api.post(
        endpoint + "/update_domaine_competence",
        data
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async deleteDomaineCompetence(id) {
    try {
      const result = await api.post(endpoint + "/delete_domaine_competence", {
        id: id,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getDomaineCompetenceList(filtre) {
    try {
      const result = await api.get(endpoint + "/domaine_competence_list", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  //formation
  async getFormationById(id) {
    try {
      const result = await api.get(endpoint + "/formation_info", {
        params: { formation_id: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insertFormation(data) {
    try {
      const result = await api.post(endpoint + "/insert_formation", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async updateFormation(data) {
    try {
      const result = await api.post(endpoint + "/update_formation", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async deleteFormation(id) {
    try {
      const result = await api.post(endpoint + "/delete_formation", {
        formation_id: id,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getFormationList(filtre) {
    try {
      const result = await api.get(endpoint + "/formation_list", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  //autre competence
  async getAutreCompetenceById(id) {
    try {
      const result = await api.get(endpoint + "/find_autre_competence", {
        params: { id_competence: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insertAutreCompetence(data) {
    try {
      const result = await api.post(
        endpoint + "/insert_autre_competence",
        data
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async updateAutreCompetence(data) {
    try {
      const result = await api.post(
        endpoint + "/update_autre_competence",
        data
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async deleteAutreCompetence(id) {
    try {
      const result = await api.post(endpoint + "/delete_autre_competence", {
        id_competence: id,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getautreCompetenceList(filtre) {
    try {
      const result = await api.get(endpoint + "/autre_competence_list", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getDomaineList(filtre) {
    try {
      const result = await api.get(endpoint + "/liste_domaine", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getSousDomaineList(filtre) {
    try {
      const result = await api.get(endpoint + "/liste_sous_domaine", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getFiliereList(filtre) {
    try {
      const result = await api.get(endpoint + "/liste_filiere", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
